import groq from 'groq';

import { ASSET, CLOUDINARY_VIDEO, OVERLINE } from '../common';

export const TEXT_MEDIA_SPLIT = groq`
  _type,
  ${OVERLINE},
  title,
  description,
  isDisplayMediaLeft,
  layout,
  aspectRatio,
  media[0]{
    _type,
    _type == 'altImage' => {
      ${ASSET}
    },
    _type == 'video' => {
      title,
      controls,
      url
    },
    _type == 'gif' => {
      ${CLOUDINARY_VIDEO}
    },
    _type == 'storyVideo' => {
      ${CLOUDINARY_VIDEO},
    }
  },
  video,
  image { ${ASSET} },
  isTableLayout,
  steps[] {
    label,
    description
  },
  quote-> {
    text,
    attribution -> {
      name,
      role,
      image { ${ASSET} }
    }
  },
  link {
    title,
    href
  }
`;

export const TEXT_MEDIA_SPLIT_BLOCK = groq`
  _type == 'textMediaRef' => {
    isDisplayMediaLeft,
    textMediaSection -> {
      ${TEXT_MEDIA_SPLIT}
    }
  }
`;
